import { render, staticRenderFns } from "./storageStatus.vue?vue&type=template&id=1a6a898b&scoped=true"
import script from "./storageStatus.vue?vue&type=script&lang=js"
export * from "./storageStatus.vue?vue&type=script&lang=js"
import style0 from "./storageStatus.vue?vue&type=style&index=0&id=1a6a898b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6a898b",
  null
  
)

export default component.exports